<div class="mc-bpm-consume">
  <h5 class="bz-font-weight--semibold">{{'BPU_MONITOR.TITLE' | translate}}</h5>
  <div class="mc-bpm-consume__download__button">
    <div class="mc-bpm-consume__download__button--left">
      <svg class="bz-icon-svg bz-icon-svg--24">
          <use href="#icon-pdf-file"></use>
      </svg>
      <label class="mc-bpm-consume__download__button__text">{{'BPU_MONITOR.BUTTON_TEXT' | translate}}</label>
    </div>
    <svg  (click)="downloadReport()" *ngIf="!showLoading" class="mc-bpm-consume__download__button__icon bz-icon-svg bz-icon-svg--16">
        <use href="#icon-download"></use>
    </svg>
    <bzg-loading size="s" *ngIf="showLoading"></bzg-loading>
  </div>
</div>
